/**
 * @generated SignedSource<<7e00e8415e8d669dab99679f7eba165e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "NO_CREDITS" | "PROCESSING" | "WAITING";
export type MultiImageFusionInput = {
  aspectRatio?: string | null;
  background?: string | null;
  customPrompt?: string | null;
  effectPreset?: string | null;
  layoutPreset?: string | null;
  moodPreset?: string | null;
  productImageUrls: ReadonlyArray<string>;
  saveToLibrary: boolean;
};
export type tasksStartMultiImageFusionMutation$variables = {
  input: MultiImageFusionInput;
};
export type tasksStartMultiImageFusionMutation$data = {
  readonly startMultiImageFusion: {
    readonly createdAt: string;
    readonly state: AIStudioTaskState;
    readonly taskId: number;
  };
};
export type tasksStartMultiImageFusionMutation = {
  response: tasksStartMultiImageFusionMutation$data;
  variables: tasksStartMultiImageFusionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MultiImageFusionTask",
    "kind": "LinkedField",
    "name": "startMultiImageFusion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tasksStartMultiImageFusionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tasksStartMultiImageFusionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cd2d244ceb6ac0228fca8e9a839895cb",
    "id": null,
    "metadata": {},
    "name": "tasksStartMultiImageFusionMutation",
    "operationKind": "mutation",
    "text": "mutation tasksStartMultiImageFusionMutation(\n  $input: MultiImageFusionInput!\n) {\n  startMultiImageFusion(input: $input) {\n    taskId\n    state\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f699cc459711ded42f27b01a476464a";

export default node;
